import * as Constants from './constants'

export const giaoHangListRequest = (formData) => {
  return {
    type: Constants.GIAOHANG_LIST_REQUESTING,
    payload: formData
  }
}

export const giaoHangListSuccess = (data) => {
  return {
    type: Constants.GIAOHANG_LIST_SUCCESS,
    data
  }
}

export const giaoHangListError = (error) => {
  return {
    type: Constants.GIAOHANG_LIST_ERROR,
    error
  }
}

export const giaoHangDetailRequest = (formData) => {
  return {
    type: Constants.GIAOHANG_DETAIL_REQUESTING,
    payload: formData
  }
}

export const giaoHangDetailSuccess = (data) => {
  return {
    type: Constants.GIAOHANG_DETAIL_SUCCESS,
    data
  }
}

export const giaoHangDetailError = (error) => {
  return {
    type: Constants.GIAOHANG_DETAIL_ERROR,
    error
  }
}

export const giaoHangUpdateRequest = (formData, callback) => {
  return {
    type: Constants.GIAOHANG_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const giaoHangUpdateSuccess = (response) => {
  return {
    type: Constants.GIAOHANG_UPDATE_SUCCESS,
    payload: response
  }
}

export const giaoHangUpdateError = (error) => {
  return {
    type: Constants.GIAOHANG_UPDATE_ERROR,
    error
  }
}

export const giaohangListNvRequest = (formData, callback) => {  
  return {
    type: Constants.GIAOHANG_LIST_NV_REQUESTING,
    formData,
    callback
  }
}

export const giaohangListNvSuccess = (data) => {  
  return {
    type: Constants.GIAOHANG_LIST_NV_SUCCESS,
    data
  }
}

export const giaohangListNvError = (error) => {  
  return {
    type: Constants.GIAOHANG_LIST_NV_ERROR,
    error
  }
}
export const giaohangKhoXuatRequest = (formData) => {
  return {
    type: Constants.GIAOHANG_KHOXUAT_REQUESTING,
    payload: formData
  }
}

export const giaohangKhoXuatSuccess = (data) => {
  return {
    type: Constants.GIAOHANG_KHOXUAT_SUCCESS,
    data
  }
}

export const giaohangKhoXuatError = (error) => {
  return {
    type: Constants.GIAOHANG_REPORT_KHOXUAT_ERROR,
    error
  }
}
export const giaohangExportXlsRequest = (formData, onSuccess) => {
  return {
    type: Constants.GIAOHANG_EXPORT_XLS_REQUESTING,
    payload: formData,
    onSuccess
  }
}

export const giaohangExportXlsSuccess = () => {
  return {
    type: Constants.GIAOHANG_EXPORT_XLS_SUCCESS,
  }
}

export const giaohangExportXlsError = (error) => {
  return {
    type: Constants.GIAOHANG_EXPORT_XLS_ERROR,
    error
  }
}



// WEBPACK FOOTER //
// ./src/views/GiaoHang/actions.js